import { isMac } from '@/utils/platform';

const MODIFIER_LABELS_MAC: Record<string, string> = {
  mod: '⌘',
  meta: '⌘',
  cmd: '⌘',
  command: '⌘',
  ctrl: '⌃',
  control: '⌃',
  alt: '⌥',
  option: '⌥',
  shift: '⇧',
};

const MODIFIER_LABELS_OTHER: Record<string, string> = {
  mod: 'Ctrl',
  meta: 'Meta',
  cmd: 'Meta',
  command: 'Meta',
  ctrl: 'Ctrl',
  control: 'Ctrl',
  alt: 'Alt',
  option: 'Alt',
  shift: 'Shift',
};

/**
 * Convert a react-hotkeys-hook combo (e.g. "mod+shift+a") into a
 * platform-appropriate display label ("⌘⇧A" on Mac, "Ctrl+Shift+A" elsewhere).
 */
export function formatHotkeyLabel(keys: string): string {
  const parts = keys
    .toLowerCase()
    .split('+')
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length === 0) return keys;

  const mac = isMac();
  const modifierLabels = mac ? MODIFIER_LABELS_MAC : MODIFIER_LABELS_OTHER;
  const modifiers: string[] = [];
  let key = '';

  for (const part of parts) {
    const modifier = modifierLabels[part];
    if (modifier) {
      modifiers.push(modifier);
      continue;
    }
    key = part.length === 1 ? part.toUpperCase() : capitalize(part);
  }

  if (mac) {
    return `${modifiers.join('')}${key}`;
  }

  return [...modifiers, key].filter(Boolean).join('+');
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
